import { render, staticRenderFns } from "./Page-with-boxed-layout.vue?vue&type=template&id=6046cee3&"
import script from "./Page-with-boxed-layout.vue?vue&type=script&lang=js&"
export * from "./Page-with-boxed-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports